import { Badge } from 'slab'

import { type EnrollmentEventType } from './types'

const eventTypesOutput: Record<EnrollmentEventType, string> = {
  ichra_invite: 'ICHRA Invite',
  open_enrollment: 'Open Enrollment',
  special_enrollment: 'Special Enrollment',
}

const eventSubtypesOutput: Record<string, string> = {
  loss_of_coverage: 'Loss of Coverage',
  relocation: 'Relocation',
  birth_or_adoption: 'Birth/Adoption',
  marriage: 'Marriage',
  divorce_or_legal_separation: 'Divorce/Legal Separation',
  death_of_dependent: 'Death of Dependent',
  cobra_expiration: 'COBRA Expiration',
  loss_of_subsidy_eligibility: 'Loss of Subsidy Eligibility',
  thatch_incident: 'Thatch Incident',
  other: 'Other',
  renewal: 'Renewal',
}

const EnrollmentEventPill = ({
  enrollmentType,
  enrollmentSubtype,
}: {
  enrollmentType: EnrollmentEventType
  enrollmentSubtype?: string
}) => {
  return (
    <Badge
      type={getEnrollmentEventBadgeType(enrollmentType)}
    >
      Event: {eventTypesOutput[enrollmentType]}{' '}
      {enrollmentSubtype &&
        `(${eventSubtypesOutput[enrollmentSubtype] || enrollmentSubtype})`}
    </Badge>
  )
}

function getEnrollmentEventBadgeType (enrollmentType: EnrollmentEventType) {
  switch (enrollmentType) {
    case 'ichra_invite':
      return 'neutral'
    case 'open_enrollment':
      return 'caution'
    case 'special_enrollment':
      return 'warning'
    default:
      return 'neutral'
  }
}

export default EnrollmentEventPill
